import {CAD_3D_DATA_PACKAGE, parsePackageVersionTags, UNRESOLVED_VERSION} from './packageVersionTags';

export const resolveTexturesVersion = (raw?: string): string | undefined => {
  const version = parsePackageVersionTags(raw)[CAD_3D_DATA_PACKAGE];
  return version && version !== UNRESOLVED_VERSION ? version : undefined;
};

/**
 * Hands @ergeon/cad the resolved version of the 3d-data this build serves; the library keys
 * its IndexedDB texture cache on it, and without one it clears that cache before every image.
 */
export const configureCad3d = (): void => {
  const texturesVersion = resolveTexturesVersion(import.meta.env.ERGEON_PACKAGE_VERSIONS);
  if (!texturesVersion) {
    // Loud on purpose: a texture cache that disables itself looks like nothing at all from
    // the outside, and warn is the one console level production builds keep.
    console.warn(
      `cad texture cache disabled: no resolved @ergeon/${CAD_3D_DATA_PACKAGE} version in the build-time map`,
    );
    return;
  }
  // The global is declared by @ergeon/cad. Picking it by name makes tsc fail when cad renames
  // or drops it: with noImplicitAny off, a bare globalThis.config3d would compile as any.
  const cadGlobal: Pick<typeof globalThis, 'config3d'> = globalThis;
  cadGlobal.config3d = {...cadGlobal.config3d, texturesVersion};
};
